<script>
  import { duplicateIcon } from "../../../Utils/utilConstants.svelte";

  import {
    copyObjContent,
    getActivityLogsActionType,
    getDisplayUserName,
    getFormatDateAndTime,
    getText,
  } from "../../../Utils/utilFunctions.svelte";

  import { CardLayout } from "../index.svelte";

  export let logDetails = {};

  $: btnOptions = [
    {
      iconName: "copyIcon",
      iFont: duplicateIcon,
      hasTooltip: true,
      tooltip: "Copy content",
      iconFunction: () => copyContent(),
    },
  ];

  $: displayData = [
    {
      label: "Action Time:",
      value: logDetails?.createdDate
        ? getFormatDateAndTime(logDetails.createdDate)
        : "",
    },
    {
      label: "User:",
      value: getDisplayUserName(logDetails),
    },
    {
      label: "Doctor:",
      value: logDetails?.accountName ? logDetails.accountName : "-",
    },
    {
      label: "Controller:",
      value: getText(logDetails?.controller),
    },
    {
      label: "Action Type:",
      value: getActivityLogsActionType(logDetails?.actionType),
    },
    {
      label: "Action:",
      value: getText(logDetails?.entityName),
    },
    {
      label: "User Agent:",
      value: getText(logDetails?.userAgent),
    },
    {
      label: "IP:",
      value: getText(logDetails?.ip),
    },
    {
      label: "Source:",
      value: getText(logDetails?.source),
    },
  ];

  const copyContent = () => {
    const copyObj = {};

    displayData.map((data) => (copyObj[data.label] = data.value));

    copyObjContent(copyObj, "Basic Information Copied!");
  };
</script>

<CardLayout title="Basic Information" {btnOptions}>
  <div class="flex flex-col p-2 w-full gap-y-3">
    {#each displayData as data}
      <div class="flex flex-row gap-x-2">
        <p class="title">{data.label}</p>
        <p class="content cursor-default">{data.value}</p>
      </div>
    {/each}
  </div>
</CardLayout>

<style>
  .title {
    width: 150px;
  }

  .content {
    width: calc(100% - 150px);
  }
</style>
